import React from 'react';
import PropTypes from 'prop-types';
import { TabContent, TabPane } from 'reactstrap';
import { getQuery } from 'client/utils/location';
import { noop } from 'lodash-es';
import { VIN_TAB } from 'site-modules/shared/components/appraisal/appraisal-tabs-container/appraisal-tab-constants';
import { LicensePlateTabContainer } from 'site-modules/shared/components/appraisal/appraisal-tabs/license-plate-tab/license-plate-tab-container';
import { AppraisalTabLink } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/shared/appraisal-tab-link';

export function TabsContent({
  tabs,
  activeTabId,
  storage = null,
  onTabLinkClick,
  onPrepopulatedVehicle,
  onAddressVin,
  isMobile = false,
  isSellCar = false,
  isSellInCityState = false,
  isWIDG1125chal1 = false,
  creativeId = undefined,
  ctaText = undefined,
  ctaClassName = undefined,
  location = {},
  isVdpEmbedded = false,
  isYearDropdownFirst = true,
  initialStateCode = '',
  initialVehicle = null,
  setStylesAndVin = noop,
  isLookUpStyleView = false,
  isFullWidth = false,
  isProfileOfferVinPrepopulationEnabled = false,
  profileOfferVin = '',
  hasAddressToVinDrawer = false,
  isBackgroundStyleTabEnabled = false,
  isEmoSearchEnabled = false,
  isAppraisalLanding = false,
  setModelValue = noop,
  isPrivatePartyBtn = false,
}) {
  const query = getQuery(location);
  const vinTabLink = <AppraisalTabLink onClick={onTabLinkClick} tabLink={VIN_TAB} />;

  return (
    <TabContent activeTab={activeTabId}>
      {tabs.map(({ id, TabComponent }) =>
        activeTabId === id ? (
          <TabPane tabId={id} key={`tab-${id}`} data-testid={`tab-${id}`}>
            <TabComponent
              handlePrepopulatedVehicle={onPrepopulatedVehicle}
              isMobile={isMobile}
              isSellCar={isSellCar}
              isSellInCityState={isSellInCityState}
              isWIDG1125chal1={isWIDG1125chal1}
              creativeId={creativeId}
              ctaText={ctaText}
              btnClassName={ctaClassName}
              query={query}
              isVdpEmbedded={isVdpEmbedded}
              isYearDropdownFirst={isYearDropdownFirst}
              initialStateCode={initialStateCode}
              initialVehicle={initialVehicle}
              setStylesAndVin={setStylesAndVin}
              isLookUpStyleView={isLookUpStyleView}
              isFullWidth={isFullWidth}
              useUniqId={isLookUpStyleView}
              hasAddressToVinDrawer={hasAddressToVinDrawer}
              profileOfferVin={isProfileOfferVinPrepopulationEnabled ? profileOfferVin : undefined}
              isAppraisalLanding={isAppraisalLanding}
              storage={storage}
              isActiveTab
              vinTabLink={vinTabLink}
              isBackgroundStyleTabEnabled={isBackgroundStyleTabEnabled}
              isEmoSearchEnabled={isEmoSearchEnabled}
              activeTabId={activeTabId}
              updateVinAndContinue={onAddressVin}
              setModelValue={setModelValue}
              isPrivatePartyBtn={isPrivatePartyBtn}
              licensePlateAndVinForm={
                <LicensePlateTabContainer
                  storage={storage}
                  isMobile={isMobile}
                  creativeId={creativeId}
                  ctaText="Continue"
                  query={query}
                  setStylesAndVin={setStylesAndVin}
                  isFullWidth
                  isAddressTab
                  isVinByAddressOverlay
                  vinTabLink={vinTabLink}
                  isActiveTab
                />
              }
            />
          </TabPane>
        ) : null
      )}
    </TabContent>
  );
}

TabsContent.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      TabComponent: PropTypes.elementType,
    })
  ).isRequired,
  activeTabId: PropTypes.string.isRequired,
  onTabLinkClick: PropTypes.func.isRequired,
  onPrepopulatedVehicle: PropTypes.func.isRequired,
  onAddressVin: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  isSellCar: PropTypes.bool,
  isSellInCityState: PropTypes.bool,
  isWIDG1125chal1: PropTypes.bool,
  creativeId: PropTypes.string,
  ctaText: PropTypes.string,
  ctaClassName: PropTypes.string,
  location: PropTypes.shape({}),
  isVdpEmbedded: PropTypes.bool,
  isYearDropdownFirst: PropTypes.bool,
  initialStateCode: PropTypes.string,
  initialVehicle: PropTypes.shape({}),
  setStylesAndVin: PropTypes.func,
  isLookUpStyleView: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isProfileOfferVinPrepopulationEnabled: PropTypes.bool,
  profileOfferVin: PropTypes.string,
  hasAddressToVinDrawer: PropTypes.bool,
  isBackgroundStyleTabEnabled: PropTypes.bool,
  isEmoSearchEnabled: PropTypes.bool,
  isAppraisalLanding: PropTypes.bool,
  setModelValue: PropTypes.func,
  storage: PropTypes.shape({}),
  isPrivatePartyBtn: PropTypes.bool,
};
